import { IBarScaleStyle } from '../models/index.js';
export const barScaleStyle: IBarScaleStyle = {
	children: {
		wrapper: {
			display: 'block',
			margin: {
				_value: '0',
			},
			padding: {
				_value: '0',
			},
		},
	},
};
